import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Route, Router } from '@angular/router';
import { SimpleSearch } from 'src/app/core/models/simple-search.model';
import { IdentityResource } from '../models/identity-resource.model';
import { UserService } from '../services/user.service';

@Component({
    selector: 'list-identity-resources',
    templateUrl: './list-identity-resources.component.html',
    standalone: false
})
export class ListIdentityResourcesComponent implements OnInit {

    public resources: IdentityResource[];
    public isLoading: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private userService: UserService) {
            this.resources = [];
    }

    ngOnInit(): void {

        this.route.queryParamMap
            .subscribe(params => {

                let search = new SimpleSearch();
                this.isLoading = true;

                this.userService.listIdentityResources(search)
                    .then(response => {
                        console.log('## Identity Resources ##', response);
                        this.resources = response.identityResources;
                        this.isLoading = false;
                    }).catch(error => {
                    });
            });

    }

}



